import React, { ReactNode, createContext, useContext, useReducer } from 'react';
import { mapboxReducer } from '../reducer/mapbox-reducer';

export interface IMapboxStyleLayers {
    layerId: string;
    visible: boolean;
}

export interface ICoordinates {
    lat: number;
    lng: number;
}

export interface IInitialState  {
    style: string;
    isOpenSettings: boolean;
    isOpenDataDrawer: boolean;
    isOpenFilterDrawer: boolean
    styleLayers: IMapboxStyleLayers[];
    coordinates: ICoordinates;
    lotArea: number | null;
    clickProperties: { [key: string]: any };
    setMapboxStyle: (value: string) => void;
    setMenuSettings: (value:boolean) => void;
    setStyleLayers: (value: IMapboxStyleLayers[]) => void;
    setCoordinates: (value: ICoordinates) => void;
    setClickProperties: (values: {}) => void;
    setIsOpenDataDrawer: (value:boolean) => void;
    setIsOpenFilterDrawer: (value:boolean) => void;
    setLotArea: (value:number) => void;
}

const initialState = {
    style: "mapbox://styles/lagarsoft/cljej4m1a00ag01p59ssebwcc",
    isOpenSettings: false,
    styleLayers: [],
    coordinates: {lng: -73.990791576914, lat: 40.750905029809},
    clickProperties: {},
    isOpenDataDrawer: false,
    isOpenFilterDrawer: false,
    lotArea: -1,
    setMapboxStyle() {},
    setMenuSettings() {},
    setStyleLayers() {},
    setCoordinates() {},
    setClickProperties() {},
    setIsOpenDataDrawer() {},
    setIsOpenFilterDrawer() {},
    setLotArea() {},
}


const MapboxContext = createContext<IInitialState>(initialState);

const MapboxProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(mapboxReducer, initialState);

    const setMapboxStyle = (value:string) => {
        dispatch({
            type: "SET_MAPBOX_STYLE",
            payload: value
        })
    }

    const setMenuSettings = (value:boolean) => {
        dispatch({
            type: "SET_MENU_SETTINGS",
            payload: value
        })
    }

    const setStyleLayers = (value:IMapboxStyleLayers[]) => {
        dispatch({
            type: "SET_STYLE_LAYERS",
            payload: value
        })
    }

    const setCoordinates = (value:ICoordinates) => {
        dispatch({
            type: "SET_COORDINATES",
            payload: value
        })
    }

    const setClickProperties = (value:{}) => {
        dispatch({
            type: "SET_CLICK_PROPERTIES",
            payload: value
        })
    }
    const setIsOpenDataDrawer = (value:boolean) => {
        dispatch({
            type: "SET_MENU_DATA_STATE",
            payload: value
        })
    } 

       const setIsOpenFilterDrawer = (value:boolean) => {
        dispatch({
            type: "SET_MENU_FILTER_STATE",
            payload: value
        })
        
    } 
    
    const setLotArea = (value:number) => {
        dispatch({
            type: "SET_LOT_AREA",
            payload: value
        })
        
    } 
  
    const value = {
        style: state?.style,
        isOpenSettings: state?.isOpenSettings,
        styleLayers: state?.styleLayers,
        coordinates: state?.coordinates,
        clickProperties: state.clickProperties,
        isOpenDataDrawer: state.isOpenDataDrawer,
        isOpenFilterDrawer: state.isOpenFilterDrawer,
        lotArea: state.lotArea,
        setMapboxStyle,
        setMenuSettings,
        setStyleLayers,
        setCoordinates,
        setClickProperties,
        setIsOpenDataDrawer,
        setIsOpenFilterDrawer,
        setLotArea
      };

    return (
      <MapboxContext.Provider value={ value }>
        {children}
      </MapboxContext.Provider>
    );
  };

  const useMapboxContext = (): IInitialState => useContext(MapboxContext);
  
  export { MapboxContext, MapboxProvider, useMapboxContext };